import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=4c8bdd93&scoped=true&"
import script from "./pie.vue?vue&type=script&lang=ts&"
export * from "./pie.vue?vue&type=script&lang=ts&"
import style0 from "./pie.vue?vue&type=style&index=0&id=4c8bdd93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8bdd93",
  null
  
)

export default component.exports